// 更新: 20160128
window._parent = window.parent;
window._top = window.top;
document._all = document.all;

window.parent = 'fuck ad parent';
window.top = 'fuck ad top';
document.all = ['fuck game ad'];

$(function () {
	fuck_ad();

	setTimeout(function () {
		fuck_ad();
	}, 100);

	setTimeout(function () {
		fuck_ad();
	}, 1000);
});

function fuck_ad () {
	//第一版 20150501
	$('iframe').hide();
	$('iframe.souche-iframe').show();

	//第二版 20150505
	$('t:d').hide();
	$('.tlba, .ta-color-yellow').hide();
}


//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/qiwa-common_m/lib/fuck_ad.js
// module id = 276
// module chunks = 4